<script>
import { Bar,Line } from 'vue-chartjs'
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  extends: Bar,
  name: 'BarChart',
  props: ['chartdata', 'options', 'range'],
  mounted () {
    const legendPlugin =  {

      id: "increase-legend-spacing",
      beforeInit(chart) {
        // Get reference to the original fit function
        const originalFit = chart.legend.fit;

        // Override the fit function
        chart.legend.fit = function fit() {
          // Call original function and bind scope in order to use `this` correctly inside it
          originalFit.bind(chart.legend)();
          // Change the height as suggested in another answers
          this.height += 75;
        }
      }
    };
    this.addPlugin(legendPlugin)
    this.addPlugin(chartjsPluginAnnotation);
    this.addPlugin(ChartDataLabels)

    this.renderChart(this.chartdata, this.options);
  },
  watch: {
    range(newV, oldV) {
      this.renderChart(this.chartdata, this.options)
    },
    chartdata(newV, oldV) {
      this.renderChart(this.chartdata, this.options)
    },
    options(newV, oldV) {
      this.renderChart(this.chartdata, this.options)
    }
  },
}
</script>

<style>
</style>